import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { AnalyticsFacade, PageAnalyticParams } from '@amfam/shared/analytics';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { ConfirmationModel, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../../core/store';
import { ContactAdjuster } from '../contact-adjuster.model';

@Component({
  selector: 'app-contact-adjuster-confirmation',
  templateUrl: './contact-adjuster-confirmation.component.html',
  styleUrls: ['./contact-adjuster-confirmation.component.scss'],
  standalone: false
})
export class ContactAdjusterConfirmationComponent implements OnInit {
  @Input() contactInfo: ContactAdjuster;
  @Input() contactAdjusterConfirmationHeader: string;

  public confirmationData: ConfirmationModel;

  // **** Start of Analytics data for this component
  private pageAnalytic: PageAnalyticParams = {
    pageName: 'MyAccount:Claims:ContactAdjuster:Complete',
    experience: '',
    primaryCategory: 'My Account',
    subCategory1: 'Claims',
    subCategory2: '',
    subCategory3: ''
  };
  // **** End of Analytics data for this component

  constructor(
    private store: Store<fromRoot.RootState>,
    private pageTitle: PageTitleService,
    private analyticsFacade: AnalyticsFacade
  ) {}

  public backToClaims() {
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/claims']
      })
    );
  }

  ngOnInit() {
    this.pageTitle.set('Contact Your Claims Adjuster');
    this.analyticsFacade.trackPage(this.pageAnalytic);
    this.buildConfirmationData();
  }

  buildConfirmationData() {
    this.confirmationData = {
      confirmation: {
        heading: this.contactAdjusterConfirmationHeader
      }
    };
  }
}
